import { Injectable } from "@angular/core";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { Observable } from "rxjs";
import { SplashOptions } from "./splash-dialog";
import { SplashDialogComponent } from "./splash-dialog.component";


@Injectable()
export class SplashDialogService {

    private openHandle: MatDialogRef<SplashDialogComponent> | null = null;

    constructor(private matDialog: MatDialog, private snackbar: MatSnackBar) { }

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Close Splash Method

    CloseSplash() {
        if (this.openHandle) {
            this.openHandle.close();
            this.openHandle = null;
        }
    }

    // #endregion

    // #region Display Splash Method

    DisplaySplash(options?: SplashOptions): Observable<any> {
        this.openHandle = this.matDialog.open<SplashDialogComponent>(SplashDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Please wait',
                MessageText: 'Loading...',
                ShowProgressBar: true,
                ...options,
            },
        });

        return this.openHandle.afterOpened();
    }

    // #endregion

    // #region Snackbar Warning Method

    SnackbarWarning(message: string, options?: any): MatSnackBarRef<TextOnlySnackBar> {
        const config: MatSnackBarConfig = {
            panelClass: ['warning'],
            duration: options?.duration || 5500,
            horizontalPosition: options?.horizontalPosition || 'end',
            verticalPosition: options?.verticalPosition || 'top',
        };

        return this.snackbar.open(message, undefined, config);
    }

    // #endregion

    // #region Snackbar Error Method

    SnackbarError(message: string, options?: any, hold?: boolean): MatSnackBarRef<TextOnlySnackBar> {
        const config: MatSnackBarConfig = {
            panelClass: ['error'],
            duration: options?.duration || 5500,
            horizontalPosition: options?.horizontalPosition || 'end',
            verticalPosition: options?.verticalPosition || 'top',
        };

        let action: string | undefined = void 0;

        if (hold === true) {
            action = 'OK';
            config.duration = 5 * 60 * 1000; // 5 minutes?
        }

        return this.snackbar.open(message, action, config);
    }

    // #endregion

    // #region Snackbar Info Method

    SnackbarInfo(message: string, options?: any): MatSnackBarRef<TextOnlySnackBar> {
        const config: MatSnackBarConfig = {
            panelClass: ['info'],
            duration: options?.duration || 5500,
            horizontalPosition: options?.horizontalPosition || 'end',
            verticalPosition: options?.verticalPosition || 'top',
        };

        return this.snackbar.open(message, undefined, config);
    }

    // #endregion

    // #region Snackbar Success Method

    SnackbarSuccess(message: string, options?: any): MatSnackBarRef<TextOnlySnackBar> {
        const config: MatSnackBarConfig = {
            panelClass: ['success'],
            duration: options?.duration || 5500,
            horizontalPosition: options?.horizontalPosition || 'end',
            verticalPosition: options?.verticalPosition || 'top',
        };

        return this.snackbar.open(message, undefined, config);
    }

    // #endregion

}